type ModelsCarouselConfig = {
  apiKey: string;
  url: string;
  launchDarklyClientKey: string;
  nodeEnv: string;
};

export const getConfigurationByEnv = (baseUrl?: string) => {
  let configs: ModelsCarouselConfig;

  const defaultConfig: ModelsCarouselConfig = {
    apiKey: '',
    launchDarklyClientKey: '',
    url: 'https://qa.vwmodelscarouselfeatureapp.svc.vwusa.io',
    nodeEnv: '',
  };

  if (baseUrl) {
    configs = {
      ...defaultConfig,
      url: baseUrl,
    };
  } else {
    configs = {
      ...defaultConfig,
    };
  }

  return configs;
};
